import { render } from 'preact';

import '@shared/styles/index.scss';
import './index.css';
import App from '@manage-cards/App';
import {
	generateBrowserFingerprint,
	getFingerprintCookie,
} from '@manage-cards/utils/fingerPrint.utils';

if (!getFingerprintCookie()) {
	generateBrowserFingerprint();
}
const root = document.getElementById('root');
render(<App />, root!);
